import Fuse from 'fuse.js'
import type { LotMatchPartner, MatchOverviewData, PopMatchPartner } from '$mapapp/data/data.model'

type FuseItem = {
	match: MatchOverviewData
	label: string
	address: string
	type: string
}

function toFuseItem(match: MatchOverviewData): FuseItem {
	const { partner } = match
	const type =
		partner.objType === 'lot'
			? (partner as LotMatchPartner).materialName
			: ((partner as PopMatchPartner).type?.shortText ?? '')
	return { match, label: partner.label, address: partner.address, type }
}

const FUSE_OPTIONS: Fuse.IFuseOptions<FuseItem> = {
	keys: ['label', 'address', 'type'],
	threshold: 0.35,
	minMatchCharLength: 2,
	ignoreLocation: true
}

/**
 * Filters `entries` to those whose match's label, address, or material/location type
 * passes a fuzzy search for `term`. The original sort order is preserved.
 * Returns `entries` unchanged when `term` is empty.
 */
export function searchMatchEntries(
	entries: [string, MatchOverviewData][],
	term: string | undefined
): [string, MatchOverviewData][] {
	if (!term?.trim()) return entries
	const items = entries.map(([, match]) => toFuseItem(match))
	const fuse = new Fuse(items, FUSE_OPTIONS)
	const passing = new Set(fuse.search(term).map((r) => r.item.match))
	return entries.filter(([, match]) => passing.has(match))
}
